




































































































import Vue, { VNode, CreateElement  } from 'vue';
import UUIFComponent from '@/shared/uuifComponent';
import { Component, Watch } from 'vue-property-decorator';
import { TableColumnConfig, TableEntry, ColumnsAdjustRequestData, ColumnSortRequestData, SortedColumnInfo } from '@libs-uuif/shared/sw-table';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import  { SwTextfield, SwExpandableTextfield } from '@libs-uuif/shared/sw-textfield';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
import { ContentToolbarExpandFilterBlock } from '@libs-uuif/shared/sw-content-toolbar';
import { SwSlider } from '@libs-uuif/shared/sw-slider';
import { productsTab } from '@/modules/msw-products';

interface ViewDescriptor {
  key: string;
  label: string;
}
const cssPrefix = 'multiactivationstatus';

@Component({
  components:{
    ...UUIFComponent,
    SwExpandableTextfield,
    SwTextfield,
    SwForm,
    SwFormRow,
    SwRadio,
    SwSlider,
  },
})
export default class MultiActivationStatus extends SwExtendedVue {
  cssPrefix = cssPrefix;
  // for table
  serviceStatusArr:any[] = [];
  isIframed:boolean = false;
  isLoadingTableData: boolean = false;
  selectedTableRows:any[] = [];
  tableData: any[] = [];
  // for expansion
  expandVisible: boolean = false;
  columnSearchValues:ViewDescriptor[] = [
    { label: (this.$t('multiactivationstatus.all')
      .toString()), key:'All' },
    { label: (this.$t('multiactivationstatus.activated')
      .toString()), key:'Activated' },
    { label: (this.$t('multiactivationstatus.failed')
      .toString()), key:'Failed' },
  ];
  selectedColumnSearchOption:string = 'All';
  // for expansion search filter
  searchInputText:string = '';
  isExpandSearchFilter: boolean = false;
  searchInputChips:string[] = [];
  // for date filter
  selectedDateRange:string = 'All';
  dateFilterCategories:string[] = ['Today', 'Yesterday', 'Last 7 days', 'Last 30 days', 'Last 90 days', 'Last 180 days', 'All'];
  registeredOnSelectValue: string;
  // for sorting
  sortedColumns: SortedColumnInfo[] = [{
    colKey: 'date',
    ascending: true,
  }];

  @Watch('selectedColumnSearchOption')
  onStatusChange () {
    if (this.expandVisible) {
      this.onselectColumnSearchValue(this.selectedColumnSearchOption);
    }
  }
  @Watch('selectedDateRange')
  private updateDateFilterTiltle() {
    if (this.$refs.regDtFilterSlider) {
      const datetitle = this.selectedDateRange;
      ((this.$refs.regDtFilterSlider as SwSlider).$refs.sliderBtn as HTMLElement).title = datetitle;
    }
  }

  serviceActivationTableConfig: TableColumnConfig[] = [
    {
      key: 'index',
      type: 'index',
      width:100,
    },
    {
      key: 'status',
      dataKey: 'status',
      sorter: true,
      width: 150,
      title: (this.$t('multiactivationstatus.status')
      .toString()),
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
              <div class={[`${cssPrefix}__celltext`]}>
                   { data.entry.activated }
              </div>
        ) as VNode;
      },
    },
    {
      key: 'batchid',
      dataKey: 'batchid',
      sorter: true,
      width: 150,
      title: (this.$t('multiactivationstatus.batchId')
      .toString()),
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
              <div class={[`${cssPrefix}__celltext`]}>
                   { data.entry.batchID }
              </div>
        ) as VNode;
      },
    },
    {
      key: 'date',
      dataKey: 'date',
      sorter: true,
      width: 150,
      title: (this.$t('multiactivationstatus.date')
      .toString()),
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
              <div class={[`${cssPrefix}__celltext`]}>
                   { data.entry.fileUploadedOn }
              </div>
        ) as VNode;
      },
    },
    {
      key: 'serNo',
      dataKey: 'serNo',
      sorter: true,
      width: 150,
      title: (this.$t('multiactivationstatus.serNum')
      .toString()),
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
              <div class={[`${cssPrefix}__celltext`]}>
                   { data.entry.serialnumber }
              </div>
        ) as VNode;
      },
    },
    {
      key: 'actkey',
      dataKey: 'actkey',
      sorter: true,
      title: (this.$t('multiactivationstatus.activationKey')
      .toString()),
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
              <div class={[`${cssPrefix}__celltext`]}>
                   { data.entry.activationKey }
              </div>
        ) as VNode;
      },
    },
    {
      key: 'remark',
      dataKey: 'remark',
      sorter: true,
      width: 250,
      title: (this.$t('multiactivationstatus.remark')
      .toString()),
      render:(h: CreateElement, data: { entry: TableEntry }): VNode => { // tslint:disable-line
        return (
              <div class={[`${cssPrefix}__celltext`]}>
                   { this.renderRemarkColumn(h, data) }
              </div>
        ) as VNode;
      },
    },
  ];

  dateRangeChanged(value:string, dragorStep:any) {
    this.selectedDateRange = value;
    if (dragorStep === 'step') {
      this.dateRangeDragDone();
    }
  }
  dateRangeDragDone() {
    this.handleRegisteredOnFilter(this.selectedDateRange);
    this.applyDateFilter();
    this.filterAllData(this.searchInputText, true);
    this.filterData(this.selectedColumnSearchOption, true);
  }
  handleRegisteredOnFilter(value:string) {
    switch (value) {
      case 'Today':
        this.registeredOnSelectValue = '0';
        break;
      case 'Yesterday':
        this.registeredOnSelectValue = '1';
        break;
      case 'Last 7 days':
        this.registeredOnSelectValue = '7';
        break;
      case 'Last 30 days':
        this.registeredOnSelectValue = '30';
        break;
      case 'Last 90 days':
        this.registeredOnSelectValue = '90';
        break;
      case 'Last 180 days':
        this.registeredOnSelectValue = '180';
        break;
      default:
        this.registeredOnSelectValue = 'all';
        break;
    }
  }

  applyDateFilter(isExternal:boolean = false) {
    if (!isExternal) {
      this.tableData = this.serviceStatusArr;
    }
    switch (this.registeredOnSelectValue) {
      case '0':
        const today: Date = new Date();
        this.tableData = this.tableData.filter((product) => {
          const regDate = new Date(product.fileUploadedOn);
          return regDate.getDate() === today.getDate() && regDate.getMonth() === today.getMonth() && regDate.getFullYear() === today.getFullYear();
        });
        break;
      case '1':
        const yesterday: Date = new Date();
        yesterday.setDate(new Date().getDate() - 1);
        this.tableData = this.tableData.filter((product) => {
          const regDate = new Date(product.fileUploadedOn);
          return regDate.getDate() === yesterday.getDate() && regDate.getMonth() === yesterday.getMonth() && regDate.getFullYear() === yesterday.getFullYear();
        });
        break;
      case '7':
        const last7days: Date = new Date();
        last7days.setDate(new Date().getDate() - 7);
        last7days.setHours(0, 0, 0, 0);
        this.tableData = this.tableData.filter((product) => { return product.fileUploadedOn && new Date(product.fileUploadedOn) >= last7days; });
        break;
      case '30':
        const last30days: Date = new Date();
        last30days.setDate(new Date().getDate() - 30);
        last30days.setHours(0, 0, 0, 0);
        this.tableData = this.tableData.filter((product) => { return product.fileUploadedOn && new Date(product.fileUploadedOn) >= last30days; });
        break;
      case '90':
        const last90days: Date = new Date();
        last90days.setDate(new Date().getDate() - 90);
        last90days.setHours(0, 0, 0, 0);
        this.tableData = this.tableData.filter((product) => { return product.fileUploadedOn && new Date(product.fileUploadedOn) >= last90days; });
        break;
      case '180':
        const last180days: Date = new Date();
        last180days.setDate(new Date().getDate() - 180);
        last180days.setHours(0, 0, 0, 0);
        this.tableData = this.tableData.filter((product) => { return product.fileUploadedOn && new Date(product.fileUploadedOn) >= last180days; });
        break;
      default:
        // do nothing
    }
  }

  renderRemarkColumn(h: CreateElement, data: { entry: TableEntry }) { // tslint:disable-line
    const cell = [];
    if (data.entry.activated !== 'Failed' && data.entry.serviceStatus) {
      cell.push(<div class={[`${cssPrefix}__celltext`]}> { data.entry.serviceStatus }</div>);
    } else {
      if (data.entry.failureReason) {
        cell.push(<div class={[`${cssPrefix}__celltext`]}> { data.entry.failureReason }</div>);
      }
    }
    return cell;
  }

  get tableHeight() {
    if (this.expandVisible) {
      return this.isIframed ? 'calc(100vh - 185px - 215px)' : 'calc(100vh - 300px - 215px)';
    }
    return this.isIframed ? 'calc(100vh - 185px)' : 'calc(100vh - 300px)';
  }

  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        { title: 'Status', content: this.viewColumnFilterRender, width: 320 },
        { title: 'Registered On', content:this.viewDateFilter, width:400 },
      ],
    ];
  }
  onRefreshData() {
    this.getMultiActivationServiceStatus();
    this.selectedDateRange = 'All';
    this.selectedColumnSearchOption = 'All';
    this.searchInputText = '';
    this.searchInputChips = [];
    this.handleRegisteredOnFilter(this.selectedDateRange);
    this.applyDateFilter(true);
  }
  onRequestColumnAdjust(data: ColumnsAdjustRequestData) {
    this.serviceActivationTableConfig.forEach((col) => {
      const adjustInfo = data[col.key];
      if (!adjustInfo) { return; }
      Vue.set(col, 'width', adjustInfo);
    });
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }
  get vieColumnDesc(): ViewDescriptor[] {
    return this.columnSearchValues.map((val: any) => {
      return {
        key: val.key,
        label: val.label,
      };
    });
  }

  viewDateFilter(h:CreateElement) :VNode { //tslint:disable-line
    return (
      <SwSlider
        {...{
          props:{
            value:this.selectedDateRange,
            categories:this.dateFilterCategories,
            size: 'large',
            withDropdown: true,
          },
          attrs:{
            title:this.selectedDateRange,
          },
          on:{
            change: this.dateRangeChanged,
            'drag-done':this.dateRangeDragDone,
          },
        }}></SwSlider>
    ) as VNode;
  }

  viewColumnFilterRender(h: CreateElement) :VNode { // tslint:disable-line
    return (
        <SwForm props-layout-only={true}>
        {
          this.vieColumnDesc.map<VNode>((val: any) => {
            return (
              <SwFormRow no-label>
                <div class={['sw-flexbox__flex']}>
                  <SwRadio
                    {...{
                      props: {
                        name : val.label,
                        value : val.key,
                        pickedValue : this.selectedColumnSearchOption,
                      },
                      nativeOn: {
                        change: (event : any) => {
                          const clickedValue = event.target.value;
                          this.selectedColumnSearchOption = clickedValue;
                        },
                      },
                    }}> { val.label } </SwRadio>
                </div>
                <div class={['sw-flexbox__flex-none', 'csc-filter-item-subtotal']}>{ val.count }</div>
              </SwFormRow>
            ) as VNode;
          })
        }
      </SwForm>
    ) as VNode;
  }
  created() {
    this.isIframed = location !== parent.location;
  }
  mounted() {
    this.getMultiActivationServiceStatus();
    this.tableData = this.serviceStatusArr;
  }
  clearFilter() {
    this.selectedColumnSearchOption = 'All';
    this.tableData = this.serviceStatusArr;
    this.filterAllData(this.searchInputText, true);
    this.applyDateFilter(true);
  }
  filterAllData(ser:string, isExternal:boolean = false) {
    if (!isExternal) {
      this.tableData = this.serviceStatusArr;
    }
    this.tableData = this.tableData.filter((product) => {
      return  product['activated'].toLowerCase()
                                  .indexOf(ser) > -1 ||
              product['activationKey'].toLowerCase()
                                      .indexOf(ser) > -1 ||
              product['batchID'].toLowerCase()
                                .indexOf(ser) > -1 ||
              product['serialnumber'].toLowerCase()
                                     .indexOf(ser) > -1 ||
              product['fileUploadedOn'].toLowerCase()
                                       .indexOf(ser) > -1 ||
              product['serviceStatus'].toLowerCase()
                                      .indexOf(ser) > -1 ||
              product['failureReason'].toLowerCase()
                                      .indexOf(ser) > -1;
    });
  }
  handleSearchFilter(event:any) {
    this.searchInputText = event;
    this.filterAllData(this.searchInputText);
  }
  closeSearchFilter() {
    this.isExpandSearchFilter = false;
    if (this.searchInputText !== '') {
      this.searchInputText = this.searchInputText.trim()
                                                 .toLowerCase();
      this.searchInputChips = [];
      this.addInputChip(this.searchInputText);
      this.filterAllData(this.searchInputText);
      this.filterData(this.selectedColumnSearchOption, true);
      this.applyDateFilter(true);
    }
  }
  filterData(value:any, isExternal:boolean = false) {
    if (!isExternal) {
      this.tableData = this.serviceStatusArr;
    }
    if (value === 'All') {
      if (!isExternal) {
        this.tableData = this.serviceStatusArr;
      } else {
        this.tableData =  this.tableData;
      }
      return;
    }
    this.tableData = this.tableData.filter((product) => {
      return  product['activated'] === value;
    });
  }
  addInputChip(value:string) {
    this.searchInputChips.push(value);
  }
  removeInputChip() {
    this.searchInputText = '';
    this.filterAllData(this.searchInputText);
    this.filterData(this.selectedColumnSearchOption, true);
    this.applyDateFilter(true);
    this.searchInputChips = [];
  }
  onselectColumnSearchValue(value:any) {
    if (value === 'All') {
      this.selectedColumnSearchOption = 'All';
      this.filterData(value);
      this.filterAllData(this.searchInputText, true);
      this.applyDateFilter(true);
    } else {
      this.filterData(this.selectedColumnSearchOption);
      this.filterAllData(this.searchInputText, true);
      this.applyDateFilter(true);
    }
  }
  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }
  get getServiceStatusArray() {
    const data: TableEntry[] = [];
    this.tableData.forEach((entry: any, index: any) => {
      const newEntry: TableEntry = Object.assign({}, entry);
      newEntry._key = index.toString();
      newEntry._selectable = true;
      data.push(newEntry);
    });
    return data;
  }
  getMultiActivationServiceStatus() {
    const userID = this.$store.getters.getUserId;
    this.$store.dispatch('MswProductsStoreModule/getMultiActivationStatus', userID)
        .then((response:any) => {
          this.$store.commit('stopLoading');
          if (response.operationStatus === 'OK') {
            this.isLoadingTableData = false;
            const data:any[] = [];
            response.arrMultiMultiKeyActivationStatus.forEach((arr:any) => {
              arr.arrAutoServiceActivationStatus.forEach((item: any) => {
                const temp = { batchID: item.batchID,
                  fileUploadedOn: arr.fileUploadedOn,
                  serialnumber: item.serialnumber,
                  activationKey: item.activationKey,
                  activated: item.activated,
                  serviceStatus: item.serviceStatus,
                  dtfileUploadedOn: arr.dtfileUploadedOn,
                  failureReason: item.failureReason };
                data.push(temp);
              });
            });
            this.serviceStatusArr = data;
            this.tableData = this.serviceStatusArr;
          } else if (response.operationStatus === 'NOK') {
            this.isLoadingTableData = false;
          }
        });
  }
  navigateBack() {
    this.$router.push({ path: `/m/feature/${productsTab.path}` });
  }
}
